import { createSelector } from "reselect";
import { omit } from "lodash";
import getBrowserInfo from "@/util/getBrowserInfo";
import getCurrentUrl from "@/util/getCurrentUrl";
import getCacheBuster from "@/util/getCacheBuster";
import getVersion from "@/util/getVersion";

("use strict");

const prefix = "sidebar";

const SAVE_STATE = `${prefix}/SAVE_STATE`;

const saveState = (url, serializedState) => ({ type: SAVE_STATE, payload: { url, serializedState } });

export function saveBugReport() {
  return function (dispatch, getState) {
    const currentState = getState();
    const browserInfo = getBrowserInfo();
    const cacheBuster = getCacheBuster();
    const clientVersion = getVersion();
    const reportDate = new Date().toISOString();
    const serializedState = serializeStateForBugReport({ reduxState: omit(currentState, "bugReport"), browserInfo, cacheBuster, clientVersion, reportDate });
    dispatch(saveState(getCurrentUrl(), serializedState));
  };
}

const baseSelector = (state) => state.bugReport;

export const getSavedState = createSelector(baseSelector, (state) => state.savedState);

export const getSavedUrl = createSelector(baseSelector, (state) => state.savedUrl);

function serializeStateForBugReport(state) {
  const removePasswordReplacer = (key, value) => (/password/gi.test(key) && typeof value === "string" ? "***" : value);
  return JSON.stringify(state, removePasswordReplacer);
}

const initialState = {
  savedUrl: null,
  savedState: null,
};

export default function bugReport(state = initialState, action) {
  switch (action.type) {
    case SAVE_STATE:
      return {
        ...state,
        savedUrl: action.payload.url,
        savedState: action.payload.serializedState,
      };

    default:
      return state;
  }
}
